import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const STATUS_META = {
  new: { label: "New", bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
  awaiting_resume: { label: "Awaiting Resume", bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" },
  awaiting_voice: { label: "Awaiting Voice", bg: "#FAF5FF", text: "#7E22CE", border: "#E9D5FF" },
  complete: { label: "Complete", bg: "#ECFDF5", text: "#047857", border: "#A7F3D0" },
  review: { label: "In Review", bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
  interview: { label: "Interview", bg: "#ECFEFF", text: "#0E7490", border: "#A5F3FC" },
  rejected: { label: "Rejected", bg: "#F4F4F5", text: "#52525B", border: "#E4E4E7" },
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}
